import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import {App, App2} from './App';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <App />,
  document.getElementById("root")
);
ReactDOM.render(
  <App2 />,
  document.getElementById("root2")
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

//
